import AppContext from 'pages/AppContext';

let accessToken = AppContext.persistentStore.getItem("cmsAccessToken") || null;

export default {
    accessToken: accessToken,
    loginErrorMessage: null,
    user: null,
    resettingPassword: false
}



// WEBPACK FOOTER //
// ./public/pages/Login/initialState.js